import { createContext } from "react";

import mapboxgl from "mapbox-gl";

export const MapContext = createContext<mapboxgl.Map | null>(null);
